import http from '../api'
import env from '../config/env'
import md5 from '../components/md5'
// import storeData from '../store/index'
export default {
  // initWxGetToken() {
  //   console.log('env', env.env)
  //   if (env.env === 'test') {
  //     window.location.href= 'https://testmoawx.hotwater.com.cn/cfwechat/static/oauth2.html?appid=wx6c1fa6673a17c2d8&scope=snsapi_base&redirect=https%3A%2F%2Ft-nextm.aosmarketing.com.cn%2Fcampaign%2F%23%2Fmaterial%2Flist%3Ftype%3D161%26appid%3Dwx6c1fa6673a17c2d8'
  //   }else if (env.env === 'pro') {
  //     window.location.href=`https://weixin.aosmith.com.cn/cfwechat/static/oauth2.html?appid=wx7e6847ed17a9a919&scope=snsapi_base&redirect=https%253a%252f%252fnextm.aosmarketing.com.cn%252fcampaign%252f%2523%252fmaterial%252flist%3Ftype%3D161%26appid%3Dwx7e6847ed17a9a919`
  //   }
  // },
  getUrlParam(search = "", key) {
    var param = [];
    var result = "";
    console.log('search', search)
    if (search && search.length > 0) {
      if (search.indexOf("&&") == -1) {
        param = search && search.split("?").length > 1 ? search.split("?")[1].split("&") : '';
      } else {
        param = search && search.split("?").length > 1 ?  search.split("?")[1].split("&&") : '';
      }
      for (var i = 0; i < param.length; i++) {
        if (param[i].indexOf(key + "=") != -1) {
          result = param[i].split("=")[1];
          break;
        }
      }
    }
    return result;
  },
  // getWxToken(code) {
  //   alert('getWxToken:  '+JSON.stringify(code))
  //   if(code) {
  //     http.get(`aocampaignsales/openapi/wxmp/web-page-token/${code}`).then(
  //       (res) => {
  //         alert('res'+JSON.stringify(res))
  //         storeData.commit('updateWxToken', res.data['access_token'])
  //         console.log('wxToken111',storeData.state.wxToken)
  //       }
  //     ).catch((err) => {
  //       alert('err'+JSON.stringify(err))
  //     })
  //   }
  // },
  /**
   * 获取url中 ?后面的search值，并转换为key value的对象值
   * @param {String} url
   * @returns {Object}
   */
  getSearch(url) {
    let search = {}
    if (url.indexOf('#') > 0) {
      url = url.split('#')[0]
    }
    if (url.indexOf('?') > 0){
      let ar2 = url.split('?')
      if (ar2[1].length) {
        let temp = ar2[1].split('&')
        for (let i = 0; i < temp.length; i++) {
          let qar = temp[i].split('=')
          if (qar.length === 2) {
            search[qar[0]] = qar[1]
          }else{
            search[qar[0]] = null
          }
        }
      }
    }
    return search
  },
  // 转义
  replaceSpecialChar(url) {
    url = url.replace(/&quot;/g, '"')
    url = url.replace(/&amp;/g, '&')
    url = url.replace(/&lt;/g, '<')
    url = url.replace(/&gt;/g, '>')
    url = url.replace(/&nbsp;/g, ' ')
    console.log('转义字符', url)
    return url
  },
  // 存储code 2.0
  saveKeyNew(key, params) {
    http.get(
      `aocampaign/openapi/common/parms/store?key=${encodeURIComponent(
        key
      )}&parms=${params}`
    )
  },
  // 对象转数组
  ObjectToArray(obj) {
    const arr = []
    for (let key in obj) {
      arr.push(obj[key])
    }
    return arr
  },
  sleep(t) {
    new Promise((s) => {
      setTimeout(() => {
        s()
      }, t * 1000)
    })
  },
  // 格式化数字
  formatNum(value) {
    if (!value) return 0
    if (typeof value === 'string') {
      value = +value
    }
    if (value > 99999999) {
      return (value / 100000000).toFixed(1) + '亿'
    }
    if (value > 9999) {
      return (value / 10000).toFixed(1) + '万'
    }
    return value
  },
  qsUrl(obj) {
    let url = ``
    for (let key in obj) {
      if (url.indexOf('?') === -1) {
        url = url + `?${key}=${obj[key]}`
      } else {
        url = url + `&${key}=${obj[key]}`
      }
    }
    return url
  },
  // 获取海报二维码2.0
  getPosterNew(query, url = 'pages/detail') {
    console.log('-----------------')

    const scene = md5.b64Md5(`${this.ObjectToArray(query).join('&')}`)
    this.saveKeyNew(scene, this.ObjectToArray(query).join('%26'))
    console.log(scene)
    const params = {
      page: url,
      scene,
    }
    return new Promise((s) => {
      http
        .post(`aocampaign/openapi/unlimited-qr-code/${env.appId}`, params)
        .then((res) => {
          console.log(res)
          s(res.data)
        })
    })
  },

  // 换短链接
  changeUrl(url) {
    return this.changeUrlV2(url)
  },

  // 换短链接
  // Deprecated: 因腾讯接口变动，停止使用 2024.06.06
  changeUrlV1(url) {
      return new Promise((s) => {
        http
          .post(
            `aocampaign/openapi/user/change-short-url?url=${encodeURIComponent(
              url
            )}`
          )
          .then((res) => {
            s(res.data)
          })
          .catch(() => s())
      })
  },

  // 换短链接：自建短链接接口
  changeUrlV2(url, source = 'material') {
    const longUrl = encodeURIComponent(url)
    const signStr = `longUrl=${url}&sourceType=${source}&appkey=Aos@!2022`
    const signV = md5.hexMD5(signStr).toUpperCase()
    
    return new Promise((s) => {
      http
        .get(
          `aocampaignsales/openapi/s-u/longUrl2shortUrlSign?longUrl=${longUrl}&sourceType=${source}&sign=${signV}`
        )
        .then((res) => {
          s(res.data)
        })
        .catch(() => s())
    })
  },
}
